import sharedConstants from "@lib/shared_constants";

export const engagementSendOutcomesAbortLogData =
  "/:app_group_id/messaging_diagnostics/send_outcomes_abort_log" as const;

export const abortLogChannels = [
  sharedConstants.CHANNELS.EMAIL,
  sharedConstants.CHANNELS.SMS,
  sharedConstants.CHANNELS.IOS_PUSH,
  sharedConstants.CHANNELS.ANDROID_PUSH,
  sharedConstants.CHANNELS.WEB_PUSH,
  sharedConstants.CHANNELS.KINDLE_PUSH,
  sharedConstants.CHANNELS.CONTENT_CARDS,
  sharedConstants.CHANNELS.WEBHOOK,
  sharedConstants.CHANNELS.TRIGGER_IN_APP_MESSAGE,
  sharedConstants.CHANNELS.BANNER,
  sharedConstants.CHANNELS.LINE,
  sharedConstants.CHANNELS.WHATS_APP,
] as const;
